import React from "react";
import './Listslider.css';
import axios from "axios";
import Slider from "react-slick";
import  './Slidearrow.css';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
class Listslider extends React.Component {
  constructor(props){
    super(props);
    this.state = {
        cats : []
    }


 
}
componentDidMount(){
    console.log(this.props.minilist)
  axios.get(process.env.REACT_APP_API_URL + 'api/method/ecom.api.get_item_group_Byroute?route=products/'+this.props.minilist, {
                  headers : {
              'content-type': 'application/json'}
      })
      .then(response=>{
          this.setState({cats:response.data['message']})
      })
  
}

  render() {
    var settings = {
      dots: false,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 2000,
      slidesToShow: 6,
      slidesToScroll: 1,
      pauseOnHover: true,
       nextArrow: (
        <div>
          <div className="next-slick-arrow mob-d-none"> <ArrowForwardIosIcon/> </div>
        </div>
      ),
    prevArrow: (
        <div>
           <div className="next-slick-arrow mob-d-none"> <ArrowBackIosNewIcon/> </div>
        </div>
      ), 
      responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              arrows: false,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2,
              arrows: false,
            }
          },
          {
            breakpoint: 480,
            settings: {
                infinite: true,
                autoplay: true,
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
            }
          }
        ]
  }
    return <div className="clearfix mb-2">
              <div id="categories2">
                    
                        <div className="pt-3 shop-menu-resp"> 
                        <Slider {...settings}>
                          {this.state.cats.map((itm,k)=>{
                                        return(  
                              <a  key={k} className="" href={'/'+itm.route}>
                                <div className="cate-size mob-shop-box-size pt-1" >{itm.image ? <img src={process.env.REACT_APP_API_URL +itm.image}alt="" className="" /> : <img src="/assets/images/logo/no-image.png"/>}
                                  <h5 className="cat-head">{itm.name}</h5>
                                </div>
                              </a> )
                                        })}
                           
                               
                            
                           </Slider>
                          </div>
                      </div>
              
         {/*  <p className="list-product">No products Found</p> */}
        
         
    </div>
    }
}

export default Listslider;